import React, { useState } from 'react';
import { useReservation } from './ReservationContext';
import { Card, ListGroup, Row, Col, Modal, Button } from 'react-bootstrap';
import ROOM_TYPES from './Room_Type';
import { format, parseISO } from 'date-fns';
import { InfoCircle } from 'react-bootstrap-icons';
import dayjs from 'dayjs';

export default function ReservationSummary() {
  const { reservation } = useReservation();
  const [showTaxInfo, setShowTaxInfo] = useState(false);

  const {
    checkIn = '-',
    checkOut = '-',
    nights = 1,
    rooms = [],
    adults = 0,
    children = 0,
    extraCharge = 0,
    totalBeforeTax = 0,
  } = reservation;

  const roomsCost = rooms.reduce(
    (sum, room) => sum + room.count * room.rate * nights,
    0
  );

  // --- Tax calculations ---
  const municipalTaxRate = 0.04; // 4%
  const governmentTaxRate = 0.13; // 13%

  const municipalTax = Math.round(totalBeforeTax * municipalTaxRate * 100) / 100;

  const municipalTaxHST = Math.round((  municipalTax) * governmentTaxRate * 100) / 100;


  const governmentTax = Math.round((totalBeforeTax ) * governmentTaxRate * 100) / 100;

  const totalMunicipalTaxWithHST = Math.round((municipalTax + municipalTaxHST) *100) / 100;

  //const governmentTax = Math.round((totalBeforeTax ) * governmentTaxRate * 100) / 100;

  const totalTaxes = Math.round((totalMunicipalTaxWithHST + governmentTax) * 100) / 100;
  const totalWithTax = Math.round((totalBeforeTax + totalTaxes) * 100) / 100;

  return (
    <>
      <Card className="shadow-sm border-0">
        <Card.Body>
          <Card.Title className="fw-bold mb-3">Reservation Summary</Card.Title>

          <ListGroup variant="flush" className="mb-3">
            <ListGroup.Item>
              <Row>
                <Col xs={6}><strong>Check-in:</strong></Col>
                <Col xs={6} className="text-end">
                
                  {checkIn ?  dayjs(checkIn).format('MMM D, YYYY') : '-'}
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col xs={6}><strong>Check-out:</strong></Col>
                <Col xs={6} className="text-end">
                  {checkOut ?  dayjs(checkOut).format('MMM D, YYYY'): '-'}
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col xs={6}><strong>Duration:</strong></Col>
                <Col xs={6} className="text-end">
                  {nights} night{nights === 1 ? '' : 's'}
                </Col>
              </Row>
            </ListGroup.Item>
            <ListGroup.Item>
              <Row>
                <Col xs={6}><strong>Guests:</strong></Col>
                <Col xs={6} className="text-end">
                  {adults} Adult{adults !== 1 ? 's' : ''}
                  {children > 0 ? `, ${children} Child${children !== 1 ? 'ren' : ''}` : ''}
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>

          {rooms.length > 0 ? (
            <>
              <Card.Subtitle className="mb-2 fw-semibold">Room Details</Card.Subtitle>
              {rooms.map((room, index) => (
                <Card key={index} className="mb-2 border-0 bg-light">
                  <Card.Body className="p-2">
                    <Row>
                      <Col xs={6}>
                        <strong>{ROOM_TYPES[room.roomType]?.name || room.roomType}</strong>
                      </Col>
                      <Col xs={6} className="text-end">x{room.count}</Col>
                    </Row>
                    <Row>
                      <Col xs={6}>Rate:</Col>
                      <Col xs={6} className="text-end">${room.rate}/night</Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
              <hr />
              <Row>
                <Col xs={6}><strong>Rooms Charge:</strong></Col>
                <Col xs={6} className="text-end fw-bold">${roomsCost}</Col>
              </Row>
              {extraCharge > 0 && (
                <Row>
                  <Col xs={6}><strong>Extra Person Charge:</strong></Col>
                  <Col xs={6} className="text-end text-danger fw-semibold">+${extraCharge}</Col>
                </Row>
              )}
              <hr />
              <Row>
                <Col xs={6}><strong>Total:</strong></Col>
                <Col xs={6} className="text-end fw-bold">${totalBeforeTax}</Col>
              </Row>
              <Row>
                <Col xs={6}></Col>
                <Col xs={6} className="text-end">
                  +  ${totalTaxes} taxes{' '}
                  <InfoCircle
                    role="button"
                    className="text-primary ms-1"
                    onClick={() => setShowTaxInfo(true)}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <p className="text-muted">No rooms selected.</p>
          )}
        </Card.Body>
      </Card>

      {/* --- Modal for tax breakdown --- */}
      <Modal show={showTaxInfo} onHide={() => setShowTaxInfo(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Taxes Breakdown</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-2">
            <Col xs={8}>Municipal Tax (MAT)</Col>
            <Col xs={4} className="text-end">${totalMunicipalTaxWithHST.toFixed(2)}</Col>
          </Row>
          <Row className="mb-2">
            <Col xs={8}>Government Tax (HST)</Col>
            <Col xs={4} className="text-end">${governmentTax.toFixed(2)}</Col>
          </Row>
          <hr />
          <Row>
            <Col xs={8}><strong>Total Taxes</strong></Col>
            <Col xs={4} className="text-end fw-bold">${totalTaxes.toFixed(2)}</Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTaxInfo(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
